<template>
  <transition v-if="isShow" name="popup">
    <div class="popup-back">
      <section class="popup defend-pop-wrap">
        <h1 class="popup-title" tabindex="1">해지방어 팝업</h1>
        <div class="popup-button-close">
          <a href="#" @click.prevent="clickClose()">
            <img
              src="../../assets/images/common/btn-popup-close.svg"
              alt="팝업 닫기"
            />
          </a>
        </div>

        <!-- NOTE: case1.3-자동결제 해지 선택 / case1.2에서 코인 받기 선택 케이스 -->
        <template v-if="isUnsubscribe && isGetRewords">
          <div class="pop-contents">
            <h1 class="tAc">감사합니다.</h1>
            <span class="pop-txt tAc">
              코인이 지급되었습니다.<br />
              보너스 코인은 <b class="fc-pink">MY &gt; 코인내역</b>에서 확인하실
              수 있습니다.
            </span>
            <span class="pop-dotted pop-txt01">
              <span class="icon-dotted"></span>
              웨이브 코인 : 방송VOD 단건, 영화 단건 구매 시 사용 가능
            </span>
            <span class="pop-dotted pop-txt01">
              <span class="icon-dotted"></span>
              다음 결제일에 이용권이 정상결제됩니다.
            </span>
            <span class="pop-dotted pop-txt01">
              <span class="icon-dotted"></span>
              보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지
              신청이 제한될 수 있습니다.
            </span>
            <div class="btn-pink marB0">
              <a href="#" @click.prevent="close()">확인</a>
            </div>
          </div>
        </template>

        <!-- NOTE: case1.1-자동결제 해지 선택 / 해지 팝업 / 이용권내역에서 해지하기 클릭한 모든 유저에게 첫번째로 노출 -->
        <template v-else-if="isUnsubscribe && step === 0">
          <div class="pop-top tAc">
            <img src="../../assets/images/mypooq/ico-ticket.png" alt="ticket" />
            <h1>잠시만요!</h1>
            <p class="defend-explain step1">
              <span>지금 해지하시면 <strong>매주 업데이트 되는</strong></span>
              <span
                ><strong>다양한 영화와 해외 시리즈</strong>들을 더 이상 볼 수
                없어요!</span
              >
              <span class="coin-text1">정말 해지하시겠어요?</span>
            </p>
          </div>
          <div class="pop-contents">
            <div class="ticket-table">
              <table>
                <colgroup>
                  <col style="width: 100px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <td><b>이용권명</b></td>
                    <td>
                      <div>
                        {{ data.productname }}
                      </div>
                      <div v-html="voucherDescription"></div>
                    </td>
                  </tr>
                  <tr>
                    <td><b>잔여기간</b></td>
                    <td v-if="isUpcomingPayment">
                      지금 이용권 예약을 취소해도<br />
                      남은 쿠폰 기간 동안 웨이브를 이용할 수 있어요.
                    </td>
                    <td v-else>
                      지금 이용권을 해지해도 {{ remainingTime }}까지는<br />계속
                      웨이브를 이용할 수 있어요.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tAc">
              <p class="defend-explain step1">
                <span style="color: #fff"
                  >해지하실 이용권을 다시 한 번 확인해 주세요.</span
                >
                <span class="coin-text2"
                  >LIVE 전용 이용권은 해외 시리즈 및 영화 감상 미제공</span
                >
              </p>
            </div>
            <ul class="terms-list">
              <li class="terms-item">
                <span
                  >이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가
                  가능합니다.</span
                >
              </li>
              <li class="terms-item">
                <span
                  >이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분
                  환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한
                  경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)</span
                >
              </li>
              <li class="terms-item">
                <span
                  >이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브
                  <a
                    href="https://member.wavve.com/customer/qna/ask"
                    :style="highlightTextStyle"
                    >고객센터</a
                  >에 연락해 주시기 바랍니다.</span
                >
              </li>
            </ul>
            <div class="bottom-button-container">
              <div class="btn-pink mr-8">
                <a href="#" @click.prevent="close()">취소</a>
              </div>
              <div class="btn-pink">
                <a href="#" @click.prevent="checkPromotion()">해지</a>
              </div>
            </div>
          </div>
        </template>

        <!-- NOTE: case1.2-자동결제 해지 선택 / 해지 팝업 내 해지하기 버튼 클릭 / 프로모션 적용유저에게 노출 -->
        <template v-else-if="isUnsubscribe && step === 1">
          <div class="pop-top tAc">
            <img
              src="http://img.wavve.com/service30/crm/mypooq/icon-gift-coin-pc.png"
              alt="gift-coin"
            />
            <p class="defend-explain step2">
              <span>이용권을 유지하면 감사의 의미로</span>
              <span
                ><strong class="coin-txt">{{ coinText }}</strong
                >을 드려요.</span
              >
              <span class="coin-text1"
                >코인 받고 다양한 최신 영화를 감상해 보시겠어요?</span
              >
            </p>
          </div>
          <div class="pop-contents">
            <span class="pop-tit">이용권 유지 시 혜택!</span>
            <span
              v-for="(message, index) in promotionMessage"
              :key="index"
              class="pop-dotted"
            >
              <span class="icon-dotted"></span>
              <span v-html="message"></span>
            </span>
            <p class="revocation-exclamation">
              <span>
                보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지
                신청이 제한될 수 있습니다.
              </span>
              <span>
                코인 수령 시 32일 이후 해지신청이 가능하며, 코인을 사용하지 않은
                경우 고객센터를 통해 즉시 해지신청을 요청 할 수 있습니다.
              </span>
            </p>
            <div class="btn-pink mb-30">
              <a v-if="isRequestingCoin" href="#" @click.prevent="noop"
                >코인 요청 중</a
              >
              <a v-else href="#" @click.prevent.once="getRewords()"
                >유지하고 코인 받기</a
              >
            </div>
            <div class="btn-revocation">
              <a href="#" class="gray-arrow" @click.prevent="unsubscribe()"
                >해지하기</a
              >
            </div>
          </div>
        </template>

        <!-- NOTE: case1.3-자동결제 해지 선택 / 여기로 넘어가는 케이스 확인 불가 -->
        <template v-else-if="isUnsubscribe && step === 2">
          <div class="pop-top">
            <h1>해지 이유를 남겨주세요.</h1>
          </div>
          <div class="pop-contents">
            <span class="pop-tit"
              >답해주신 소중한 정보를 바탕으로, 더 나은 서비스로
              보답하겠습니다.</span
            >
            <ul class="reason-list">
              <li>
                <div class="radio-style">
                  <input
                    id="reason01"
                    v-model="cancelDescription"
                    type="radio"
                    class="radio-pink"
                    name="reason"
                    value="찾는 콘텐츠가 별로 없어서"
                  />
                  <label for="reason01">찾는 콘텐츠가 별로 없어서</label>
                </div>
              </li>
              <li>
                <div class="radio-style">
                  <input
                    id="reason02"
                    v-model="cancelDescription"
                    type="radio"
                    class="radio-pink"
                    name="reason"
                    value="서비스 이용이 불편해서"
                  />
                  <label for="reason02">서비스 이용이 불편해서</label>
                </div>
              </li>
              <li>
                <div class="radio-style">
                  <input
                    id="reason03"
                    v-model="cancelDescription"
                    type="radio"
                    class="radio-pink"
                    name="reason"
                    value="이용 가격이 비싸서"
                  />
                  <label for="reason03">이용 가격이 비싸서</label>
                </div>
              </li>
              <li>
                <div class="radio-style">
                  <input
                    id="reason04"
                    v-model="cancelDescription"
                    type="radio"
                    class="radio-pink"
                    name="reason"
                    value="서비스 장애나 에러가 많아서"
                  />
                  <label for="reason04">서비스 장애나 에러가 많아서</label>
                </div>
              </li>
              <li>
                <div class="radio-style">
                  <input
                    id="reason05"
                    v-model="cancelDescription"
                    type="radio"
                    class="radio-pink"
                    name="reason"
                    value="타 서비스를 이용하기 때문에"
                  />
                  <label for="reason05">타 서비스를 이용하기 때문에</label>
                </div>
              </li>
              <li>
                <div class="radio-style">
                  <input
                    id="reason06"
                    v-model="cancelDescription"
                    type="radio"
                    class="radio-pink"
                    name="reason"
                    value="other"
                  />
                  <label for="reason06">다른 사유</label>
                </div>
              </li>
              <li>
                <textarea
                  v-model="cancelDescriptionOther"
                  placeholder="사유를 입력해주세요."
                  :disabled="cancelDescription !== 'other'"
                ></textarea>
              </li>
            </ul>
            <div class="tAc">
              <span class="pop-tit">해지신청을 계속하시겠습니까?</span>
            </div>
            <div class="btn-pink">
              <a href="#" @click.prevent="close()">취소</a>
            </div>
            <div class="btn-revocation">
              <a href="#" class="gray-arrow" @click.prevent="unsubscribe()"
                >해지하기</a
              >
            </div>
          </div>
        </template>

        <!-- NOTE: case2.1-해지신청취소 선택 / 프로모션 적용 유저에게 노출 -->
        <template v-else-if="!isUnsubscribe && step === 0">
          <div class="pop-top tAc">
            <img
              src="../../assets/images/mypooq/ico-gift.png"
              alt="gift-coin"
            />
            <h1>감사합니다.</h1>
            <p>
              자동결제 <b>해지신청을 취소</b>하면 선물을 드려요.<br />
              <b>선물을 받으시겠어요?</b>
            </p>
          </div>
          <div class="pop-contents">
            <span class="pop-tit">이용권 유지 혜택!</span>
            <span
              v-for="(message, index) in dataUnsubscribe.promotiontext1"
              :key="index"
              class="pop-dotted"
            >
              <span class="icon-dotted"></span>
              <span v-html="message"></span>
            </span>
            <span
              v-if="dataUnsubscribe.eventype !== 'coin'"
              class="pop-dotted pop-txt01 marT15"
            >
              <span class="icon-dotted"></span>
              현재 이용중인 이용권의 다음 결제일에 50%할인되어 결제됩니다.
            </span>
            <div class="btn-pink marB0">
              <a href="#" @click.prevent="step++">해지 취소하고 선물 받기</a>
            </div>
          </div>
        </template>

        <!-- NOTE: case2.2-해지신청 취소 선택 / 프로모션 미적용유저에게 노출 /  -->
        <template v-else-if="!isUnsubscribe && step === 1">
          <div class="pop-contents tAc">
            <h1>감사합니다.</h1>
            <span class="pop-txt">
              해지신청을 취소하겠습니까?<br />취소 시
              <b class="fc-pink">자동결제</b>가 재개됩니다.
            </span>
            <div class="btn-pink marB0">
              <a href="#" @click.prevent="cancelUnsubscribe()">확인</a>
            </div>
          </div>
        </template>

        <!-- NOTE: case2.3-해지신청 취소 선택 / 해지신청 취소 완료 / 프로모션적용 유저에게는 코인정보 노출 / 아니면 그냥 확인 버튼 -->
        <template v-else-if="!isUnsubscribe && step === 2">
          <div class="pop-contents tAc">
            <h1>감사합니다.</h1>
            <span
              v-if="dataUnsubscribe && dataUnsubscribe.promotiontext2.length"
              class="pop-txt"
              v-html="dataUnsubscribe.promotiontext2[0]"
            ></span>
            <span v-else class="pop-txt">해지신청이 취소되었습니다.</span>
            <div
              v-if="dataUnsubscribe && dataUnsubscribe.eventype === 'coin'"
              class="padH60 tAl"
            >
              <span class="pop-dotted pop-txt01 marT15">
                <span class="icon-dotted"></span>
                웨이브 코인 : 방송VOD 단건, 영화 단건 구매 시 사용 가능
              </span>
              <i class="v-gap5">공백</i>
              <span class="pop-dotted pop-txt01">
                <span class="icon-dotted"></span>
                코인은 [MY > 코인내역]에서 확인하실 수 있습니다.
              </span>
              <i class="v-gap5">공백</i>
              <span class="pop-dotted pop-txt01">
                <span class="icon-dotted"></span>
                다음 결제일에 이용권이 정상결제됩니다.
              </span>
              <i class="v-gap5">공백</i>
              <span class="pop-dotted pop-txt01">
                <span class="icon-dotted"></span>
                보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지
                신청이 제한될 수 있습니다.
              </span>
            </div>
            <div class="btn-pink marB0">
              <a href="#" @click.prevent="complete()">확인</a>
            </div>
          </div>
        </template>
      </section>
    </div>
  </transition>
</template>

<script>
  import {
    getMypurchasePassPromotion,
    postMypurchasePassCancel,
    getFromUrl,
    postMypurchasePassEvent,
    getMypurchasePassPromotionContinue,
  } from '@/common/utils/request'
  import constant from '@/common/resources/constant'
  export default {
    props: {
      data: {
        type: Object,
      },
      close: {
        type: Function,
      },
      isUnsubscribe: {
        type: Boolean,
      },
    },
    data() {
      return {
        dataUnsubscribe: undefined,
        promotionMessage: undefined,
        coinText: undefined,
        step: -1,
        isGetRewords: false,
        isShow: false,
        isRequestingCoin: false,
        cancelDescription: '찾는 콘텐츠가 별로 없어서', // 해지 사유
        cancelDescriptionOther: '', // 해지 기타 사유
        highlightTextStyle: {
          color: '#fff',
          textDecoration: 'underline',
        },
      }
    },
    computed: {
      remainingTime() {
        if (this.data && this.data.enddate) {
          return (
            this.data.enddate.substring(0, 4) +
            '.' +
            this.data.enddate.substring(5, 7) +
            '.' +
            this.data.enddate.substring(8, 10)
          )
        }
        return ''
      },
      isUpcomingPayment() {
        return this.data && this.data.upcomingpayment
      },
      voucherDescription() {
        return this.data.attributetext?.replace(
          /\$O\$/gi,
          '<span class="icon-dotted"></span>',
        )
      },
    },
    created() {
      if (!this.isUnsubscribe) {
        getMypurchasePassPromotionContinue()
          .then((response) => {
            this.step = 0
            this.isShow = true
            this.dataUnsubscribe = response.data
          })
          .catch((error) => {
            if (error.response && error.response.status === 551) {
              this.step = 1
              this.isShow = true
            }
          })
      } else {
        this.step = 0
        this.isShow = true
      }
    },
    methods: {
      noop() {
        return false
      },
      // 닫기 버튼 클릭
      clickClose() {
        // 해지방어 2차의 마지막 화면에서는 닫기 버튼 눌렀을 때 화면을 리로드 시킨다
        if (!this.isUnsubscribe && this.step === 2) {
          this.$router.back()
        } else {
          this.close()
        }
      },
      // 해지방어 프로모션 대상자인지 체크
      checkPromotion() {
        getMypurchasePassPromotion()
          .then(() => {
            this.getPromotionData()
          })
          .catch((error) => {
            if (error.response && error.response.status === 551) {
              postMypurchasePassCancel({
                productType: 'pass',
                keyId: this.isUpcomingPayment ? '0' : this.data.userserviceid,
                status: 0,
              })
                .then(() => {
                  alert(constant.MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE)
                  this.close()
                })
                .catch((err) => {
                  if (err.response.data.resultcode === '550') {
                    alert(err.response.data.resultmessage)
                    this.close()
                  }
                })
            }
          })
      },
      // 해지방어 프로모션 데이터를 가져온다.
      getPromotionData() {
        getFromUrl({
          url: 'pooq3-static-json.wavve.com/service/marketing/passevent.json',
        }).then((response) => {
          this.step = 1
          response.data.forEach((data) => {
            if (data.packagemasterid === this.data.packagemasterid) {
              this.promotionMessage = data.message
              this.coinText = data.cointext
            }
          })
        })
      },
      // 유지하고 코인 받기
      getRewords() {
        if (this.isRequestingCoin) return
        postMypurchasePassEvent({ eventType: 'cancelpass' })
          .then(() => {
            this.isGetRewords = true
          })
          .catch(() => {
            this.isRequestingCoin = false
            alert(
              '일시적 시스템 오류로 코인을 지급 할 수 없습니다. 잠시 후 다시 시도 해주시기 바랍니다.',
            )
          })
        this.isRequestingCoin = true
      },
      // 자동결제 해지
      unsubscribe() {
        postMypurchasePassCancel({
          productType: 'pass',
          keyId: this.isUpcomingPayment ? '0' : this.data.userserviceid,
          status: 0,
        }).then(() => {
          alert(constant.MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE)
          this.close()
        })
      },
      // 자동결제 해지 취소
      cancelUnsubscribe() {
        // 2차 해지방어 대상자이고 코인 지급 타입일 때
        if (this.dataUnsubscribe && this.dataUnsubscribe.eventype === 'coin') {
          postMypurchasePassEvent({ eventType: 'continuepass' }).then(() => {
            postMypurchasePassCancel({
              productType: 'pass',
              keyId: this.isUpcomingPayment ? '0' : this.data.userserviceid,
              status: 1,
            }).then(() => {
              this.step = 2
            })
          })
        } else {
          postMypurchasePassCancel({
            productType: 'pass',
            keyId: this.isUpcomingPayment ? '0' : this.data.userserviceid,
            status: 1,
          }).then(() => {
            this.step = 2
          })
        }
      },
      // 자동결제 해지 취소 완료
      complete() {
        this.close()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .popup-back {
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
    overflow-y: scroll;
  }

  .popup-enter-active,
  .popup-leave-active {
    transition: opacity 0.3s;
  }

  .popup-enter,
  .popup-leave-to {
    /* .fade-leave-active below version 2.1.8 */
    opacity: 0;
  }
  .pop-contents .icon-dotted {
    width: 3px;
    height: 3px;
    border: 1px solid #5e5e5e;
  }
  .bottom-button-container {
    display: flex;
    .btn-pink {
      flex: 1;
      &.mr-8 {
        margin-right: 8px;
      }
    }
  }

  .terms-list {
    margin-top: 30px;
    .terms-item {
      position: relative;
      font-size: 14px;
      line-height: 20px;
      color: #5e5e5e;
      padding-left: 12px;
      &::before {
        position: absolute;
        content: '•';
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }
</style>
